// extracted by mini-css-extract-plugin
module.exports = {"anim":"ChatBox_anim__xZq5W","animation":"ChatBox_animation__3Xsku"};